<template>
    <v-card elevation="1">
        <v-dialog v-model="dialog" persistent width="500">
            <v-card>
                <v-toolbar color="primary" dark flat dense cad>
                    <v-toolbar-title class="subheading">Tambah Popup Info</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="closeDialog()">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="text-xs-left">
                    <v-form v-model="valid" ref="form" lazy-validation>
                        <v-container>
                            <v-layout fluid row wrap>
                                <v-flex lg12 sm12 xs12 pa-20>
                                    <v-text-field
                                            class="padr"
                                            :rules="Rules"
                                            required
                                            label="Label"
                                            name="name"
                                            v-model="addPopup.name"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex lg12 sm12 xs12 pa-20>
                                    <v-text-field
                                            class="padr"
                                            label="Url (Optional)"
                                            name="name"
                                            v-model="addPopup.url"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex lg12 sm12 xs12>
                                    <input
                                            hidden
                                            name="imageupload"
                                            type="file"
                                            accept="image/*"
                                            ref="imageupload"
                                            v-on:change="upload($event.target.files)"
                                    />
                                </v-flex>
                                <v-flex lg12 sm12 xs12>
                                    <img
                                            id="imgpopup"
                                            class="imgslide align-center justify-center"
                                            src="https://placehold.co/200x200"
                                            alt="image"
                                            @click="openfile()"
                                            width="300"
                                            height="300"
                                    />
                                </v-flex>
                                <v-flex lg12 sm12 xs12>
                                    <v-select
                                            label="Status"
                                            item-text="text"
                                            item-value="status"
                                            v-model="addPopup.status"
                                            :items="statuses"
                                    ></v-select>
                                </v-flex>
                                <v-flex lg12 sm12 xs12 pa-20>
                                    <v-dialog
                                            ref="dialog"
                                            v-model="modaldate"
                                            :return-value.sync="addPopup.expired"
                                            persistent
                                            width="290px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    prepend-icon="event" v-on="on"
                                                    v-model="addPopup.expired"
                                                    label="Masa Aktif">

                                            </v-text-field>
                                        </template>
                                        <v-date-picker v-model="addPopup.expired" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="modaldate = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(addPopup.expired)">OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="closeform()">Cancel</v-btn>
                    <v-btn
                            :disabled="!valid"
                            :loading="loading"
                            color="success"
                            @click="simpanForm(addPopup)"
                    >Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-toolbar elevation="0" flat>
            <v-text-field
                    flat
                    solo
                    prepend-icon="search"
                    placeholder="Type something"
                    v-model="search"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="getList()">
                <v-icon dark>refresh</v-icon>
                Refresh
            </v-btn>
            <v-btn color="primary" class="white--text ml-4" @click.native="openmodal()">
                <v-icon dark>add</v-icon>
                Add
            </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
            <v-data-table
                    :headers="complex.headers"
                    :search="search"
                    :items="listpopup"
                    class="elevation-0"
                    item-key="id"
                    :loading="loading"
            >
                <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
                <template v-slot:item.image="{ item }">
                    <div class="ma-4">
                        <v-img :src="item.image" contain
                               aspect-ratio="1.5" class="pa-5">
                        </v-img>
                    </div>
                </template>
                <template v-slot:item.status="{ item }">
                    <v-chip
                            v-if="item.status===1"
                            color="green"
                            small
                            text-color="white"
                    >{{ statusformat(item.status) }}
                    </v-chip>
                    <v-chip
                            v-else
                            color="red"
                            small
                            text-color="white"
                    >{{ statusformat(item.status) }}
                    </v-chip>
                </template>
                <template v-slot:item.action="{ item }">

                        <v-btn @click.native="openFormEdit(item)" icon>
                            <v-icon color="primary">edit</v-icon>
                        </v-btn>
                        <v-btn @click.native="deleteItem(item)" icon>
                            <v-icon color="pink">delete</v-icon>
                        </v-btn>

                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        components: {},
        data: () => ({
            state_add: false,
            search: '',
            modaldate: false,
            date: new Date().toISOString().substr(0, 10),
            statuses: [
                {
                    status: 1,
                    text: 'Aktif'
                },
                {
                    status: 0,
                    text: 'NonAktif'
                }
            ],
            selected_combo: '',
            Rules: [v => !!v || 'Mohon diisi'],
            editorOption: {},
            valid: false,
            complex: {
                selected: [],
                headers: [
                    {
                        text: 'Image',
                        value: 'image'
                    },
                    {
                        text: 'Label',
                        value: 'name'
                    },
                    {
                        text: 'Status',
                        value: 'status'
                    },
                    {
                        text: 'Action',
                        value: 'action'
                    }
                ],
                items: []
            },
            delete_id: '',
            addPopup:{},
        }),
        mounted() {
            this.getList()
            this.resetimage()
        },
        computed: {
            ...mapState('Popup', ['listpopup', 'dialog', 'loading']),
            ...mapState('UploadImage', ['defaultimg','loadingupload'])
        },
        methods: {
            ...mapActions({
                logout: 'account/logout',
                AddNew: 'Popup/Add',
                EditPopup: 'Popup/Edit',
                closeDialog: 'Popup/closeDialog',
                OpenDialogForm: 'Popup/OpenDialogForm',
                getList: 'Popup/list',
                deletePopup: 'Popup/Delete',
                uploadImage: 'UploadImage/uploadImage',
                resetimage:'UploadImage/resetimage'
            }),
            closeform() {
                this.addPopup= {}
                this.closeDialog()
                this.state_add = false
                this.getList()
            },
            async openFormEdit(data) {
                console.log("Edit bos")
                this.addPopup = data
                this.state_add = false
                await this.OpenDialogForm()
                document.getElementById('imgpopup').src = this.addPopup.image

            },
            async openmodal() {

                this.state_add = true
                this.addPopup= {
                    status:1,
                    url:''
                }
                await this.OpenDialogForm()
                 let imagex = "https://placehold.co/200x200";
                document.getElementById('imgpopup').src = imagex;
                this.addPopup.image = imagex;

            },
            async simpanForm(data) {
                if (this.state_add) {
                    data.image=this.defaultimg
                    await this.AddNew(data)
                } else {
                    if(this.defaultimg.length>0){
                        data.image=this.defaultimg
                    }
                    await this.EditPopup(data)
                }
            },
            deleteItem(data) {
                this.delete_id = data.id
                this.$confirm('Yakin akan hapus ?', { color: 'red',title:'Hapus',icon:'fa-danger' }).then(res => {
                    if (res) {
                        this.deletePopup(this.delete_id)
                    }
                })
            },
            upload: function (files) {
                this.showPreview(files[0])
            },
            showPreview: function (file) {
                var reader = new FileReader()
                if(file){
                    this.uploadImage(file);
                }
                reader.onload = function (e) {
                    document.getElementById('imgpopup').src = e.target.result
                }
                reader.readAsDataURL(file)
            },
            openfile() {
                document.getElementsByName('imageupload')[0].click()
            },
            statusformat(value) {
                let a = 'Disable'
                if (value === 1) {
                    a = 'Enable'
                }
                return a
            }
        }
    }
</script>

<style scoped>
.imgslide{
    width: 250px;
    height: 250px;
    text-align: center;
}
</style>
